import { Typography } from 'antd'
import styled from 'styled-components'

export const HeaderRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: flex-end;
  padding: 0.5rem;
  margin-bottom: 1rem;
`

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 10rem;

  .filter-label {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    margin: 0;
  }

  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-inline-start: 0;
  }
`

export const ComplianceCheckboxStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`

export const DailyTableDateBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  margin-bottom: 0;
  background: ${({ theme }) => theme.primaryColor};
  color: #fff;
  font-size: 0.875rem;
  font-weight: 700;
  border-radius: 10px 10px 0 0;
`

export const DailyTableToolbar = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 12px;
`

export const DailyTableToolbarFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 12px;
`

export const DailyTableToolbarCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`

export const WeeklyMovingHeader = styled.div`
  text-align: center;
  margin-bottom: 8px;
`

export const WeeklyLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: 16px;
  margin-bottom: 12px;
  font-size: 12px;
`

export const DailyMetricsTableWrap = styled.div`
  .ant-table-summary .daily-summary-total-cell {
    background: #d8deea !important;
  }
  .daily-metrics-table.ant-table-wrapper .ant-table-tbody > tr:hover > td,
  .monthly-supplier-metrics-table.ant-table-wrapper .ant-table-tbody > tr:hover > td {
    background-color: #d5e5fe !important;
  }
  .ant-table-summary {
    border-radius: 0 0 10px 10px;
  }
  .daily-metrics-table.ant-table-wrapper .ant-table-cell-fix-left-last::after,
  .monthly-supplier-metrics-table.ant-table-wrapper .ant-table-cell-fix-left-last::after {
    border-left: 1px solid ${({ theme }) => theme.darkGray};
  }
  .ant-table-header,
  .ant-table-body {
    scrollbar-gutter: stable;
  }
  .metrics-cell-center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
  }
  .monthly-supplier-metrics-table th.header-cell-month-label:not(.no-separator):not(.no-border) {
    text-align: center;
  }
`

export const WeeklyMetricsTableWrap = styled.div`
  .weekly-metrics-summary-row > td {
    background: #e6f7ff !important;
    font-weight: 600;
  }

  .ant-table-summary .weekly-summary-total-cell {
    background: #d8deea !important;
    font-weight: 600;
  }

  .ant-table-header,
  .ant-table-body {
    scrollbar-gutter: stable;
  }

  .metrics-cell-center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
  }
`

export const ChartTitle = styled(Typography.Title)`
  color: ${({ theme }) => theme.primaryColor} !important;
  font-size: 1.25rem !important;
  font-weight: 700 !important;
  padding: 0 !important;
  margin: 0 0 16px 0 !important;
  text-align: center;
`

export const ChartEmptyWrap = styled.div`
  flex: 1;
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
`
